<cue-modal [modal]="modal" class="notch-fix">
  <cue-modal-header title="{{ translation.cancelParticipationPopup.title | transloco }}" />
  <cue-modal-body>
    <div class="modal-body">
      <p class="text-center question">
        {{ translation.cancelParticipationPopup.question | transloco }}
        {{ modalData.reservation.subject | subjectPipe }} ?
      </p>
    </div>
  </cue-modal-body>
  <cue-modal-footer>
    <cue-button (click)="modal.close(0)" [icon]="cueClose" [smallResponsive]="true">
      {{ translation.cancelParticipationPopup.close | transloco }}
    </cue-button>
    <cue-button (click)="modal.close(1)" [icon]="cueDelete" [type]="'delete'" [smallResponsive]="true">
      {{ translation.cancelParticipationPopup.cancel | transloco }}
    </cue-button>
  </cue-modal-footer>
</cue-modal>
